import { useCatchupAction } from 'src/components/Listings/InventoryActionDropdown/components/CatchupAction/useCatchupAction';

export const CatchUpAction = () => {
  const catchupAction = useCatchupAction();
  return <>{catchupAction.dropdown}</>;
};
